import React, { useState } from 'react';
import styled from 'styled-components';

import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';

export default function Notepad({ onClose, initialContent, richContent }) {
  const [docText, setDocText] = useState(initialContent ?? '');
  const [wordWrap, setWordWrap] = useState(false);

  function onClickOptionItem(item) {
    switch (item) {
      case 'Exit':
        onClose();
        break;
      case 'Word Wrap':
        setWordWrap(!wordWrap);
        break;
      case 'Time/Date':
        const date = new Date();
        setDocText(
          `${docText}${date.toLocaleTimeString()} ${date.toLocaleDateString()}`,
        );
        break;
      default:
    }
  }
  function onTextAreaKeyDown(e) {
    // handle tabs in text area
    if (e.which === 9) {
      e.preventDefault();
      e.persist();
      var start = e.target.selectionStart;
      var end = e.target.selectionEnd;
      setDocText(`${docText.substring(0, start)}\t${docText.substring(end)}`);

      // asynchronously update textarea selection to include tab
      // workaround due to https://github.com/facebook/react/issues/14174
      requestAnimationFrame(() => {
        e.target.selectionStart = start + 1;
        e.target.selectionEnd = start + 1;
      });
    }
  }

  return (
    <Div>
      <section className="np__toolbar">
        <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} />
      </section>
      {richContent ? (
        <RichContent dangerouslySetInnerHTML={{ __html: richContent }} />
      ) : (
        <StyledTextarea
          wordWrap={wordWrap}
          value={docText}
          onChange={e => setDocText(e.target.value)}
          onKeyDown={onTextAreaKeyDown}
          spellCheck={false}
        />
      )}
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  background: linear-gradient(to right, #ffffff 0%, #ffffff 100%);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .np__toolbar {
    position: relative;
    height: 21px;
    flex-shrink: 0;
    border-bottom: 1px solid white;
  }
`;

const RichContent = styled.div`
  flex: auto;
  font-family: 'Lucida Console', monospace;
  font-size: 13px;
  line-height: 1.7;
  padding: 14px 16px;
  overflow-y: scroll;
  border: 1px solid #96abff;
  color: #1a1205;

  p {
    margin: 0 0 10px 0;
  }

  p:first-child {
    margin-bottom: 12px;
  }

  b, strong {
    font-weight: bold;
  }

  a {
    color: #0000cc;
    text-decoration: underline;
    word-break: break-all;
  }

  .np__schedule {
    margin: 12px 0 12px 0;
    padding: 10px 14px;
    background: linear-gradient(135deg, #fffdf4 0%, #fff8e1 100%);
    border: 1px dashed #d4a017;
    border-radius: 4px;
    font-size: 12px;
    line-height: 2;
  }

  .np__schedule .np__schedule-title {
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 0.05em;
    margin-bottom: 6px;
    display: block;
  }

  .np__schedule .np__schedule-row {
    display: flex;
    gap: 8px;
  }

  .np__schedule .np__schedule-time {
    color: #7a5200;
    min-width: 72px;
  }

  .np__ascii {
    white-space: pre;
    font-size: 11px;
    line-height: 1.2;
    margin-top: 14px;
    color: #5a5040;
  }
`;

const StyledTextarea = styled.textarea`
  flex: auto;
  outline: none;
  font-family: 'Lucida Console', monospace;
  font-size: 13px;
  line-height: 14px;
  resize: none;
  padding: 2px;
  ${props => (props.wordWrap ? '' : 'white-space: nowrap; overflow-x: scroll;')}
  overflow-y: scroll;
  border: 1px solid #96abff;
`;
